/** @jsxImportSource @emotion/react */
import { useState } from "react";
import { accessAPI, Sidebar, Titulo, Formulario } from "../../shared";

// Mismo límite que la API (TITULO_MAXIMO en utils/asistenteMemoria.js): es lo
// que entra en una tarjeta del home.
const TITULO_MAXIMO = 60;

// Día local de un Date del calendario, como YYYY-MM-DD.
function aFechaISO(fecha) {
  const mes = String(fecha.getMonth() + 1).padStart(2, "0");
  const dia = String(fecha.getDate()).padStart(2, "0");
  return `${fecha.getFullYear()}-${mes}-${dia}`;
}

// Alta manual de un destacado de texto. Guarda lo mismo que el asistente:
// sin fecha, la tarjeta aparece en el home en el momento; con "Recordame
// en", queda solo el recordatorio y la tarjeta aparece esa mañana con el
// resumen del diario.
export default function NuevoDestacado({ visible, onHide, onCreado, toast }) {
  const [loader, setLoader] = useState(false);

  function mostrarError(detalle) {
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: detalle,
      sticky: true
    });
  }

  function crear(campos) {
    const titulo = (campos.titulo || "").trim();
    if (titulo.length > TITULO_MAXIMO) {
      mostrarError(
        `El título puede tener hasta ${TITULO_MAXIMO} caracteres (tiene ${titulo.length}). El detalle va en el texto.`
      );
      return;
    }

    let fecha = null;
    if (campos.fecha) {
      fecha = aFechaISO(new Date(campos.fecha));
      if (fecha < aFechaISO(new Date())) {
        mostrarError("La fecha del recordatorio tiene que ser hoy o posterior.");
        return;
      }
    }

    setLoader(true);
    accessAPI(
      "POST",
      "admin/misdestacados/nota",
      { titulo, texto: campos.texto || null, fecha },
      () => {
        setLoader(false);
        toast.current?.show({
          severity: "success",
          summary: fecha ? "Recordatorio guardado" : "Destacado creado",
          detail: fecha
            ? `Vas a verlo en el resumen de la mañana del ${fecha
                .split("-")
                .reverse()
                .join("/")}.`
            : undefined,
          life: 4000
        });
        onCreado(!!fecha);
      },
      (error) => {
        setLoader(false);
        mostrarError(error?.[0]?.msg || "No se pudo crear el destacado.");
      }
    );
  }

  const config = {
    secciones: [
      {
        campos: [
          {
            nombre: "titulo",
            etiqueta: "Título",
            tipoitemformularioid: 1,
            requerido: true
          },
          {
            nombre: "texto",
            etiqueta: "Texto",
            tipoitemformularioid: 11
          },
          {
            nombre: "fecha",
            etiqueta: "Recordame en",
            tipoitemformularioid: 7
          }
        ]
      }
    ],
    botones: [{ etiqueta: "Crear", callback: crear, validar: true }]
  };

  return (
    <Sidebar
      visible={visible}
      onHide={onHide}
      position="right"
      className="w-full lg:w-30rem md:w-30rem"
    >
      <Titulo>Nuevo destacado</Titulo>
      <Formulario config={config} loader={loader} />
    </Sidebar>
  );
}
